import { createFileRoute } from '@tanstack/react-router';
import { CampaignJourneyRouteView } from '@/pages/workspaces/automations/[campaignId]/journeys/routing';

function CampaignJourneyRoute() {
  const { campaignId, subjectId } = Route.useParams();
  return <CampaignJourneyRouteView campaignId={campaignId} subjectId={subjectId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/journeys/$subjectId',
)({
  component: CampaignJourneyRoute,
});
